<template lang="pug">
  div.time.comp-tspan
    TimeSpan(
      :filters="type",
      :mintspan="mintspan",
      @change="onTimespanChange")
    v-checkbox(v-model="compare",
      @change.native="updateCompared",
      :disabled="compareDisabled",
      title="对比")
    v-input(disabled v-if="!compare")
    CustomDatePicker(v-if="compare" v-bind:start-date="compareStart"
        v-bind:delta-day="deltaDay"
        v-bind:minDate="minDate"
        v-bind:maxDate="maxDate"
        v-bind:show = "datepickerShow"
        v-bind:end-date="compareEnd" v-on:update="updateRange")
    slot
</template>

<style>
.comp-tspan .checkbox {
  margin: 0 5px;

    label i {
        margin-right: 4px;
    }
}
</style>

<script>
export default {
  props: {
    compared: Boolean,
    rangeChange: Function,
    compRangeChange: Function,
    compareDisabled: Boolean,
    type: {
      type: String,
      default: '7a'
    },
    mintspan : {
      type: Number,
      default: 0
    }
  },
  data(){
    return {
      compareStart: "",
      compareEnd: "",
      compare: false,
      datepickerShow: false
    }
  },
  mounted() {
    this.compare = this.compared
    this.compareStart = this.$store.state.web.compareStart
    this.compareEnd = this.$store.state.web.compareEnd
    this.updateRange()
  },
  watch: {
    compared: function(newVal, oldVal){
      this.compare = newVal
      if(!newVal) {
        this.compareStart = ""
      }
    }
  },
  computed: {
    endDate() {
      if(this.type == 'normal') {
        return new Date().getTime()
      } else {
        return (new Date().getTime() - 24*60*60*1000)
      }
    },
    minDate() {
      return new Date(this.endDate - 365*24*60*60*1000).format('yyyy-MM-dd')
    },
    maxDate() {
      return new Date(this.endDate - this.deltaDay*24*60*60*1000).format('yyyy-MM-dd')
    },
    deltaDay(){
      let start = new Date(this.$store.state.start)
      let end = new Date(this.$store.state.end)
      let timespan= end - start
      return timespan / (24*60*60*1000)
    }
  },
  methods: {
    updateCompared() {
      if(this.compare){
        this.datepickerShow = true
      }else{
        this.updateRange()
      }
    },
    
    onTimespanChange: function({start, end}){
      if((new Date(end) - new Date(start)) > 365*24*3600*1000){
        return this.$Modal.warn(`您选择时间段超过了一年`)
      }
      this.$emit('rangeChange')
    },
    updateRange: function(date){
      if(date){
        this.compareStart = date.startDate
        this.compareEnd = date.endDate
      }
      this.$emit('compRangeChange',{compared: this.compare, compStart: this.compareStart, compEnd: this.compareEnd})
    }
  }
}
</script>



// WEBPACK FOOTER //
// comparetimespan.vue?6c69454d